import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { KpiService } from "../kpi/kpi.service";

import { Router } from "@angular/router";
import { Title } from "@angular/platform-browser";
import { Subscription } from "rxjs";

import * as _ from "lodash";
import { school } from "../store/schools/state";
import { has } from "lodash";
import { OOPS_MESSAGES } from "../constants";
import { DistrictSchools } from "../shared/interfaces";
import { LaunchDarklyService } from "../launchDarkly/launchDarkly.service";

@Component({
  selector: "school-profile",
  templateUrl: "./school-profile.component.html",
  styleUrls: ["./school-profile.component.scss"],
})
export class SchoolProfileComponent implements OnInit {
  schoolId: number;
  schoolProfile;
  schools;
  schoolsForDropdown;

  selectedSchool;
  initialSchool;
  selectedSchoolData;
  role: string;
  tier: string;
  hasAllSchools: boolean;
  useRealTimeSchoolProfileRequest: boolean = false;
  flagSubscription: Subscription;

  constructor(
    private kpiservice: KpiService,
    private route: ActivatedRoute,
    public router: Router,
    private titleService: Title,
    public launchDarklyService: LaunchDarklyService
  ) {
    this.initFlags(launchDarklyService);
    this.flagSubscription = launchDarklyService.flagChange.subscribe(() =>
      this.initFlags(launchDarklyService)
    );
  }

  initializeSchoolProfile() {
    this.kpiservice.errorMessage = null;
    this.kpiservice.getUserInfo().subscribe(
      (data) => {
        this.role = data.role;
        this.tier = data.sz_tier;
        if (has(data, "hasAllSchools")) {
          this.hasAllSchools = data.hasAllSchools;
        } else if (this.role == "admin") {
          this.hasAllSchools = true;
        } else if (this.role == "school_leader") {
          this.kpiservice.getDistrictSchools().subscribe(
            (districtSchoolsJson: DistrictSchools) => {
              this.hasAllSchools =
                data &&
                data.schools &&
                districtSchoolsJson &&
                districtSchoolsJson.schools &&
                data.schools.length == districtSchoolsJson.schools.length;
            },
            (err) => {
              console.log(err);
            }
          );
        } else {
          this.hasAllSchools = false;
        }
        this.schools = data.schools;
        this.schoolsForDropdown = _.map(this.schools, function (school: any) {
          return {
            id: school.systemSchoolId,
            text: school.officialSchoolName,
          };
        });
        this.schoolsForDropdown = _.sortBy(this.schoolsForDropdown, "text");

        this.route.params.subscribe((params) => {
          this.schoolId = params["id"];
          if (this.schoolId) {
            this.getSchoolProfile(this.schoolId);
          } else if (this.kpiservice.selectedSchoolIdInSchoolProfile) {
            // we have a selected school id in the kpi service (using as store)
            this.schoolId = this.kpiservice.selectedSchoolIdInSchoolProfile;
            this.getSchoolProfile(this.schoolId);
            window.history.replaceState(
              {},
              "",
              `/profile/school/${this.schoolId}`
            );
          } else if (this.schoolsForDropdown[0]) {
            this.schoolId = this.schoolsForDropdown[0].id;
            this.getSchoolProfile(this.schoolsForDropdown[0].id);
          } else {
            this.kpiservice.showError(
              null,
              OOPS_MESSAGES.RENDER_VIEW,
              OOPS_MESSAGES.RENDER_VIEW
            );
          }
        });
      },
      (error) => {
        console.error(error);
      }
    );
  }

  ngOnInit() {
    this.launchDarklyService
      .waitForInitialization()
      .then(() => {
        // we want to give launchDarkly a chance to fully initialize before requesting the school profile endpoints
        this.initializeSchoolProfile();
      })
      .catch((err) => {
        console.error(
          "LaunchDarkly failed to initialize! Using default flag values."
        );
        this.initializeSchoolProfile();
      });
  }

  initFlags(launchDarklyService: LaunchDarklyService) {
    this.useRealTimeSchoolProfileRequest = launchDarklyService.getFlag(
      "mosaic-ui-school-profile-real-time"
    );
  }

  selected(event) {
    this.router.navigate(["/profile/school", event.id]);
  }

  getSchoolProfile(id) {
    // Clear error messages
    this.kpiservice.errorMessage = null;
    // Save id in store
    this.kpiservice.selectedSchoolIdInSchoolProfile = id;
    this.selectedSchoolData = _.find(this.schools, ["systemSchoolId", id]);
    if (this.selectedSchoolData) {
      this.kpiservice.title = this.selectedSchoolData.officialSchoolName;
      this.setTitle(this.selectedSchoolData.officialSchoolName);
    } else {
      this.kpiservice.title = "School Profile";
    }
    this.kpiservice.getSchoolProfileById(id).subscribe(
      (data) => {
        this.schoolProfile = data;
        this.selectedSchool = { id: id, text: this.kpiservice.title };
        this.initialSchool = { id: id, text: this.kpiservice.title };
      },
      (error) => {
        this.schoolProfile = {};
        this.selectedSchool = { id: id, text: this.kpiservice.title };
        this.initialSchool = { id: id, text: this.kpiservice.title };
        this.kpiservice.showError(
          error,
          OOPS_MESSAGES.RENDER_VIEW,
          OOPS_MESSAGES.RENDER_VIEW
        );
      }
    );
  }

  setTitle(newTitle: string) {
    this.titleService.setTitle(newTitle);
  }
}
